import React, { Component } from "react";
class EditableCell extends React.Component {
  render() {
    return (
      <td className=" pt-3-half">
        <input
          type={this.props.cellData.type}
          className={`form-control ${this.props.cellData.text}`}
          readOnly={this.props.cellData.readOnly === "true"}
          name={this.props.cellData.name}
          id={this.props.cellData.id}
          min={this.props.cellData.min}
          value={this.props.cellData.value}
          onChange={this.props.onProductTableUpdate}
          style={{ width: this.props.cellData.width, height: "50px" }}
          step={this.props.cellData.step}
          required={this.props.cellData.required}
        />
      </td>
    );
  }
}
export default EditableCell;
